import styled from 'styled-components';
import { companyColor, defaultColor } from 'styles/theme';

// The spinner positions itself in the middle of the nearest positioned box.
export const Loading = styled.div`
  position: relative;
  width: 100%;
  height: 80px;
`;

export const Title = styled.div`
  color: ${defaultColor('dark')};
  font-weight: 600;
  font-size: 22px;
  line-height: 33px;
`;

export const Hint = styled.div`
  color: ${companyColor('font')};
`;
